import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { SelectGenericFromTable, SelectColumnFromTableRow, SelectRowFromTable } from '../universal/Axios';
import { GetPerformancePercentile } from '../universal/InternalCalculator';
import { CustomToolbar, GetRGBFromRelativeValue } from '../universal/GridHelper'

const GetGenAlgIndividualQuery = (dncParamIDList, gen_alg_run_id, gen_alg_generation_id, parent_id) => {
    let query = "SELECT gai.*, gag.generation_number, ";
    let queryValues = []
    for (let i = 0; i < dncParamIDList.length; i++) {
        queryValues.push("dppscm" + i + ".value as " + dncParamIDList[i]["dnc_param_id"] + "");
    }
    query += queryValues.join(", ");
    let queryJoins = []
    for (let i = 0; i < dncParamIDList.length; i++) {
        queryJoins.push(" join dnc_param_parameter_set_config_mapping dppscm" + i + " on gai.parameter_set_config_id = dppscm" + i + ".parameter_set_config_id and dppscm" + i + ".dnc_param_id = '" + dncParamIDList[i]["dnc_param_id"] + "'");
    }
    query += " from gen_alg_generation gag join gen_alg_individual gai on gag.id = gai.gen_alg_generation_id " + queryJoins.join(" ");
    if (gen_alg_run_id !== undefined) {
        query += " where gen_alg_run_id = '" + gen_alg_run_id + "'";
    } else if (parent_id !== undefined) {
        query += " where parent_id = '" + parent_id + "'";
    } else if (gen_alg_generation_id !== undefined) {
        query += " where gen_alg_generation_id = '" + gen_alg_generation_id + "'";
    }

    return query;
}


const GenAlgIndividualTable = ({ gen_alg_generation_id, gen_alg_run_id, parent_id }) => {
    const [GenAlgIndividualResultsData, setGenAlgIndividualResultsData] = useState([]);
    const [dncParamIDs, setDNCParamIDs] = useState([]);
    const [genAlgRunID, setGenAlgRunID] = useState(gen_alg_run_id);
    const [genAlgRunObject, setGenAlgRunObject] = useState([]);

    useEffect(() => {
        if (dncParamIDs.length > 0) {
            SelectGenericFromTable(GetGenAlgIndividualQuery(dncParamIDs, gen_alg_run_id, gen_alg_generation_id, parent_id), setGenAlgIndividualResultsData)
        }
    }, [dncParamIDs])

    useEffect(() => {
        if (genAlgRunID === undefined) {
            if (gen_alg_generation_id !== undefined) {
                SelectColumnFromTableRow("select gen_alg_run_id from gen_alg_generation where id = '" + gen_alg_generation_id + "';", "gen_alg_run_id", setGenAlgRunID)
            } else if (parent_id !== undefined) {
                SelectColumnFromTableRow("select gen_alg_run_id from gen_alg_generation gag join gen_alg_individual gai on gai.gen_alg_generation_id = gag.id where gai.id = '" + parent_id + "';", "gen_alg_run_id", setGenAlgRunID)
            }
        }
    }, [])

    useEffect(() => {
        SelectRowFromTable("select * from gen_alg_run where id = '" + genAlgRunID + "';", setGenAlgRunObject)
    }, [genAlgRunID])

    useEffect(() => {
        if (genAlgRunObject !== undefined) {
            SelectGenericFromTable("SELECT dnc_param_id FROM dnc_param_parameter_set_config_mapping dppscm WHERE parameter_set_config_id = '" + genAlgRunObject["base_parameter_set_config_id"] + "';", setDNCParamIDs)
        }
    }, [genAlgRunObject]);

    let GenAlgIndividualResultsColumns = [
            {
                field: 'id',
                headerName: 'ID',
                width: 500,
                renderCell: (params) => (
                    <>
                        <a
                            href={'edit-gen-alg-individual?id=' + params.row.id}
                        >
                            {params.row.id}
                        </a>
                    </>
                ),
            },
            {
                field: 'parent_id',
                headerName: 'Parent ID',
                width: 500,
                renderCell: (params) => (
                    <>
                        {parent_id == undefined ? <a
                            href={'edit-gen-alg-individual?id=' + params.row.parent_id}
                        >
                            {params.row.parent_id}
                        </a> : parent_id}

                    </>
                ),
            },
            {
                field: 'generation_number',
                headerName: 'Gen #',
                width: 90,
            },
            {
                field: 'selection_score',
                headerName: 'Selection Score',
                width: 160,
                renderCell: (params) => (
                    params.value != null ?
                        <span style={{ color: GetRGBFromRelativeValue(params.row.relative_selection_score) }}
                        >
                            {params.value.toString()}
                        </span> : <span></span>
                ),
            }, ,
            {
                field: 'median_si_sdr',
                headerName: 'Median SI-SDR',
                width: 160,
                renderCell: (params) => (
                    params.value != null ?
                        <span style={{ color: GetRGBFromRelativeValue(params.row.relative_median_si_sdr) }}
                        >
                            {params.value.toString()}
                        </span> : <span></span>
                ),
        },
            {
                field: 'mean_si_sdr',
                headerName: 'Mean SI-SDR',
                width: 160,
                renderCell: (params) => (
                    params.value != null ?
                        <span style={{ color: GetRGBFromRelativeValue(params.row.relative_mean_si_sdr) }}
                        >
                            {params.value.toString()}
                        </span> : <span></span>
                ),
        },
{
                field: 'average_speech_signal_consolidation_score',
                headerName: 'Speech Signal Consolidation Score',
                width: 160,
                renderCell: (params) => (
                    params.value != null ?
                        <span style={{ color: GetRGBFromRelativeValue(params.row.relative_average_speech_signal_consolidation_score) }}
                        >
                            {params.value.toString()}
                        </span> : <span></span>
                ),
        },
            {
                field: 'average_speech_transform_activation_score',
                headerName: 'Speech Transform Activation Score',
                width: 160,
                renderCell: (params) => (
                    params.value != null ?
                        <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_speech_transform_activation_score)) * 255) + ',' + (parseFloat(params.row.relative_average_speech_transform_activation_score) * 255) + ',0)' }}
                        >
                            {params.value.toString()}
                        </span> : <span></span>
                ),
        },
            {
                field: 'average_speech_channel_assignment_score',
                headerName: 'Speech Channel Assignment Score',
                width: 160,
                renderCell: (params) => (
                    params.value != null ?
                        <span style={{ color: GetRGBFromRelativeValue(params.row.relative_average_speech_signal_consolidation_score)}}
                        >
                            {params.value.toString()}
                        </span> : <span></span>
                ),
        },
    ];


    for (let i = 0; i < dncParamIDs.length; i++) {
        GenAlgIndividualResultsColumns.push({
            field: dncParamIDs[i]["dnc_param_id"],
            headerName: dncParamIDs[i]["dnc_param_id"],
            width: 160,
            align: 'left',
            headerAlign: 'left',
            renderCell: (params) => (
                params.value != null ?
                    <span>
                            {params.value.toString()}
                        </span> : <span></span>
                ),
            })
    }
    GenAlgIndividualResultsColumns.push({
            field: 'mean_execution_time_in_seconds',
            headerName: 'Mean Execution Time (s)',
            width: 160,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((parseFloat(params.row.relative_mean_execution_time_in_seconds)) * 255) + ',' + ((1 - parseFloat(params.row.relative_mean_execution_time_in_seconds)) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
    });
    GenAlgIndividualResultsColumns.push({
        field: 'density_network_config_id',
        headerName: 'Density Network Config',
        width: 180,
        renderCell: (params) => (
            <>
                {
                    <a
                        href={'edit-density-network-config?id=' + params.row.density_network_config_id}
                    >
                        config
                    </a>
                }
            </>
        ),
    });

    let GenAlgIndividualResultsDataRows = GenAlgIndividualResultsData?.filter(data => data != null).map((GenAlgIndividualResults) =>
    ({   
        id: GenAlgIndividualResults.id,
        parent_id: GenAlgIndividualResults.parent_id,
        parameter_set_config_id: GenAlgIndividualResults.parameter_set_config_id,
        density_network_config_id: GenAlgIndividualResults.density_network_config_id,
        generation_number: GenAlgIndividualResults.generation_number,
        median_si_sdr: GenAlgIndividualResults.median_si_sdr,
        mean_si_sdr: GenAlgIndividualResults.mean_si_sdr,
        average_speech_signal_consolidation_score: GenAlgIndividualResults.average_speech_signal_consolidation_score,
        average_speech_transform_activation_score: GenAlgIndividualResults.average_speech_transform_activation_score,
        average_speech_channel_assignment_score: GenAlgIndividualResults.average_speech_channel_assignment_score,
        selection_score: GenAlgIndividualResults.selection_score,
        mean_execution_time_in_seconds: GenAlgIndividualResults.mean_execution_time_in_seconds,
    }))

    for (let i = 0; i < GenAlgIndividualResultsData.length; i++) {
        for (let j = 0; j < dncParamIDs.length; j++) {
            GenAlgIndividualResultsDataRows[i][dncParamIDs[j]["dnc_param_id"]] = GenAlgIndividualResultsData[i][dncParamIDs[j]["dnc_param_id"]]
        }
    }

    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'mean_si_sdr', 'relative_mean_si_sdr', 0);
    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'median_si_sdr', 'relative_median_si_sdr', 0);
    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'selection_score', 'relative_selection_score', 0);
    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'average_speech_signal_consolidation_score', 'relative_average_speech_signal_consolidation_score', 0);
    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'average_speech_transform_activation_score', 'relative_average_speech_transform_activation_score', 0);
    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'average_speech_channel_assignment_score', 'relative_average_speech_channel_assignment_score', 0);
    GenAlgIndividualResultsDataRows = GetPerformancePercentile(GenAlgIndividualResultsDataRows, 'mean_execution_time_in_seconds', 'relative_mean_execution_time_in_seconds', 0);

    if (GenAlgIndividualResultsData === undefined) {
        return (<p>loading...</p>)
    }


    if (GenAlgIndividualResultsData === undefined || dncParamIDs.length === 0) {
        return (<p>loading...</p>)
    }

    return (
        <DataGrid
            disableSelectionOnClick
            rows={GenAlgIndividualResultsDataRows}
            columns={GenAlgIndividualResultsColumns}
            pagination={true}
            initialState={{
                sorting: {
                    sortModel: [{ field: 'median_si_sdr', sort: 'desc' }],
                },
            }}
            components={{
                Toolbar: () => CustomToolbar("Gen_Alg_Individuals"),
            }}
        />
    )
};

export { GenAlgIndividualTable };
